import { render, staticRenderFns } from "./TourContainer.vue?vue&type=template&id=1d488944&scoped=true"
import script from "./TourContainer.vue?vue&type=script&lang=js"
export * from "./TourContainer.vue?vue&type=script&lang=js"
import style0 from "./TourContainer.vue?vue&type=style&index=0&id=1d488944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d488944",
  null
  
)

export default component.exports